import { render } from "./QuoteEditor.vue?vue&type=template&id=7aaf1218&scoped=true"
import script from "./QuoteEditor.vue?vue&type=script&lang=js"
export * from "./QuoteEditor.vue?vue&type=script&lang=js"

import "./QuoteEditor.vue?vue&type=style&index=0&id=7aaf1218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aaf1218"]])

export default __exports__